import { Spacer as BlockheadSpacer } from '@sparemin/blockhead';
import styled from 'styled-components';

export const Spacer = styled(BlockheadSpacer).attrs({ space: '16px' })`
  width: 100%;
`;
